import './TruncatedTextTooltip.scss';
import { useId, useState } from 'react';
import { Overlay, Tooltip } from 'react-bootstrap';
import { Placement, PlacementType } from '../designConstants';
import { useIsTruncated } from '../../utils/hooks/useIsTruncated';

interface TruncatedTextTooltipProps {
  text: string;
  className: string;
  placement?: PlacementType;
}

// A manual Overlay (not OverlayTrigger) so the ref'd text node is never re-parented when the
// tooltip toggles -- re-parenting would remount the node and break the truncation
// ResizeObserver (see DashboardCard.tsx for the same pattern). Only shows a tooltip once the
// text is actually ellipsis-truncated; otherwise hovering does nothing.
export const TruncatedTextTooltip = ({
  text,
  className,
  placement = Placement.BOTTOM
}: TruncatedTextTooltipProps) => {
  const [ref, isTruncated] = useIsTruncated<HTMLDivElement>(text);
  const [hovered, setHovered] = useState(false);
  const tooltipId = useId();

  return (
    <>
      <div
        ref={ref}
        className={className}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        {text}
      </div>
      <Overlay target={() => ref.current} show={isTruncated && hovered} placement={placement}>
        <Tooltip id={tooltipId} className='truncated-text-tooltip'>
          {text}
        </Tooltip>
      </Overlay>
    </>
  );
};
